import type { PaginationType } from '../types/Pagination.types';
import type { UserVerificationDto } from './verifications.schema';
import { validateWithZod } from '@/utils/zod.utils';
import { ENDPOINTS } from '../endpoints';
import { httpClient } from '../httpClient';
import { PaginationSchema } from '../types/Pagination.types';
import { UserVerificationDtoSchema } from './verifications.schema';

export const verificationsApi = {
  async getAll(): Promise<PaginationType<UserVerificationDto>> {
    const response = await httpClient.get<PaginationType<UserVerificationDto>>(
      ENDPOINTS.verifications.list,
      { params: { page: 1, limit: 20 } },
    );
    return validateWithZod(PaginationSchema(UserVerificationDtoSchema), response);
  },
};
